import { camelizeKeys } from "humps";
import { getApiUrl, getEnvVar } from "@commons-monorepo/index";
import { ShoppingCart } from "@commons-monorepo/index";

export const fetchAbandonedCart = (abandonedId: string) =>
  fetch(
    `${getApiUrl()}/api/ms/calculator/shopping-cart/abandoned/${abandonedId}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "api-key-sumer": getEnvVar("PUBLIC_API_KEY_SP"),
      } as { [key: string]: string },
    },
  )
    .then((res) => res.json())
    .then((res) => camelizeKeys(res) as ShoppingCart);
